import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Membership from "../pages/membership/page";
import Events from "../pages/events/page";
import Resources from "../pages/resources/page";
import Contact from "../pages/contact/page";

// The admin backend is only needed by staff; load it on demand so visitors
// never download it.
const Admin = lazy(() => import("../pages/admin/page"));

const adminFallback = (
  <div className="flex min-h-screen items-center justify-center bg-silver-50 text-sm text-silver-400" role="status">
    載入後台中...
  </div>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/membership",
    element: <Membership />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    // Nested admin routes are handled inside the Admin page component.
    path: "/admin/*",
    element: (
      <Suspense fallback={adminFallback}>
        <Admin />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;